export { default } from './P7FullScreenMedia';
